<div [ngClass]="size === 'mobile'
    ? 'd-inline-flex d-lg-none'
    : 'd-none d-lg-inline-flex'" class="crezco-lang-root">

  <button type="button" class="crezco-lang-control" (click)="toggle()" [attr.aria-label]="ariaLabel"
    [attr.title]="ariaLabel">

    <svg class="crezco-lang-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">

      <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6" />

      <path d="M3.75 12H20.25" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />

      <path d="M12 3.5C14 5.85 15.05 8.65 15.05 12C15.05 15.35 14 18.15 12 20.5" stroke="currentColor"
        stroke-width="1.6" stroke-linecap="round" />

      <path d="M12 3.5C10 5.85 8.95 8.65 8.95 12C8.95 15.35 10 18.15 12 20.5" stroke="currentColor" stroke-width="1.6"
        stroke-linecap="round" />
    </svg>

    <span class="crezco-lang-text">
      {{ currentLanguageName }}
    </span>

    <span class="crezco-lang-separator" aria-hidden="true"></span>

    <span class="crezco-lang-code">
      {{ display }}
    </span>
  </button>
</div>
